<template>
  <div>
    <div class="loan-consultants">
      <div class="consultant-box">
        <div class="side">
          <img v-show="counselorInfo.logoUrl" :src="counselorInfo.logoUrl" class="media-object">
        </div>
        <div class="content">
          <div class="square">
            <img v-show="counselorInfo.wxQrcodeUrl" :src="counselorInfo.wxQrcodeUrl" style="width: 100%;">
          </div>
          <h2>
            <span class="name">{{counselorInfo.name}}</span>
            <span class="job">{{counselorInfo.profession}}</span>
          </h2>
           <div class="main">
             <ul class="list-inline">
               <li><span class="phone">电话:</span> {{counselorInfo.phone}}</li>
               <li><span class="wechat">微信:</span> {{counselorInfo.wechat}}</li>
             </ul>
              <div class="group">
                <p class="profile"><span class="intro">简介:</span>{{counselorInfo.personalProfile}}</p>
              </div>
            </div>
          <div class="order">
            <button class="orderBtn" @click="onClick">预约借款服务</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      counselorId: {
        type: String,
        required: true
      },
      loanTypeArr: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        success: false,
        counselorInfo: {}
      }
    },
    created () {
      this._fetchCounselorInfo()
    },
    methods: {
      _fetchCounselorInfo () {
        let vm = this
        this.$http({
          url: '/getCounselorInfo.jhtml',
          data: {
            counselorId: this.counselorId
          },
          done (info) {
            vm.counselorInfo = info || {}
          }
        })
      },
      onClick () {
        let from = this.$route.path.split('/').some(str => str === 'article') ? 'article' : 'counselor'
        let articleId = this.$route.query.articleId || ''
        this.$http({
          url: '/loanReservationStatistics.jhtml',
          data: {
            from: from,
            counselorId: this.counselorId,
            articleId: articleId
          }
        })
        this.showAppointment = true
        this.$store.commit('toggleAppointment', {show: true, id: this.counselorId})
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
  @import '../../stylus/mixin'
  .loan-consultants
    width 1172px
    padding 26px 0
    margin 0 auto
    .consultant-box
      width 1172px
      height 336px
      background #fff
      border-radius 5px
      margin 0 auto
      padding 28px 50px 40px
      box-shadow 0 1px 15px 3px rgba(0,0,0,0.16)
      position relative
      .side
        position absolute
        top -26px
        float left
        padding 0
        width 307px
        height 388px
        background #F1F9FF url("/static/img/counselor-info-bg.png") no-repeat center
        border-radius 5px
        overflow hidden
        border 1px solid rgba(240,240,240,1)
        box-shadow: 0 1px 15px 3px rgba(0,0,0,0.16)
        > img
          width 100%
          height 100%
      .content
        margin 0
        padding 0
        position relative
        padding-left 347px
        .square
          position absolute
          top 0
          right 0px
          width 70px
          height 70px
          overflow hidden
          background #F1F9FF url("/static/img/QR-code-bg.png") no-repeat center
          box-shadow: 0 1px 15px 3px rgba(0,0,0,0.16)
          > img
            width 100%
            height 100%
        > h2
          margin 0
          padding 0
          font-size 0
          height 33px
          margin-bottom 33px
          .name
            height 33px
            display inline-block
            line-height 33px
            max-width 250px
            ellipsis()
            font-size 30px
            letter-spacing 15px
            margin-right 26px
          .job
            height 20px
            line-height 20px
            display inline-block
            ellipsis()
            max-width 300px
            font-size 16px
            font-family "Microsoft YaHei"
            color rgb(51,51,51)
        ul.list-inline > li
          max-width 40% !important
          padding 0 30px 0 0
          ellipsis()
        .main
          margin-bottom 32px
          .group
            line-height 1.6
            font-size 16px
            letter-spacing 1px
            .profile
              position relative
              height 78px
              overflow hidden
              word-wrap break-word
              text-overflow ellipsis
              display -webkit-box
              -webkit-line-clamp 4
              -webkit-box-orient vertical
              margin 0
              padding 0
              .intro
                font-weight 900
                letter-spacing 9px
          .list-inline
            margin-bottom 20px
            font-size 16px
            letter-spacing 1px
            padding-left 5px
            .phone
              font-weight 900
              letter-spacing 9px
            .wechat
              font-weight 900
              letter-spacing 9px
        .order
          .orderBtn
            width 189px
            height 50px
            font-size 16px
            border-radius 5px
            font-family "Microsoft YaHei"
            background rgb(43,158,252)
            border 1px solid rgb(43,158,252)
            color #fff
            text-align center
            letter-spacing 4px
            text-indent 2px
            border-top-style none
            border-right-style none
            border-bottom-style none
            border-left-style none

</style>



// WEBPACK FOOTER //
// person.vue?0cc8d0c0